import { createSelector } from 'reselect';

import { AppState } from '../../store/models/app-state';
import { LoginUser, isLoginUser } from '../../features/contacts-logins/models/login-user';

const getContactsLogins = (state: AppState) => state.contactsLogins.paginatedUsers.items;

export const activeLoginsSelector = createSelector([getContactsLogins], contacts => {
    return contacts.filter(contact => isLoginUser(contact) && contact.user.isActivated) as LoginUser[];
});
